import '../reset.css';
import '../style.css';
import '../scripts/common.js';
import {initIframeResize} from './_inIFrame.js';

// Admissions paused until November. Restore the form markup and uncomment its import and initialization below.
// import {initApplicationForm} from "./apply/_applyCommon.js";

// initApplicationForm("the_island");

initIframeResize();
